<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Verträge</h1>
                    <!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                                            <route-bread-crumb></route-bread-crumb>
                                        </nav>-->
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <!--                    <base-button size="sm" type="neutral">New</base-button>
                                        <base-button size="sm" type="neutral">Filters</base-button>-->
                </div>
            </div>
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-6 col-lg-12">
                    <ContractVolume></ContractVolume>

                </div>
                <div class="col-xl-6 col-lg-12">
                    <ContractPreVolume></ContractPreVolume>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <contracts-table title="Verträge"></contracts-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContractsTable from '@/views/Tables/ContractsTable';
import StatsCard from '@/components/Cards/StatsCard';
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import ContractVolume from "@/views/Widgets/ContractVolume";
import ContractPreVolume from "@/views/Widgets/ContractPreVolume";

export default {
    name: "Contracts",
    components: {
        StatsCard,
        ContractsTable,
        RouteBreadCrumb,
        ContractVolume,
        ContractPreVolume
    },
}
</script>

<style scoped>

</style>
